import React, { useEffect, useState, useMemo } from 'react'
import styles from './styles.module.scss'
import { useHistory, useParams } from 'react-router-dom'
import ReactLoader from 'react-loader'
import { BACKEND_URL_PREFIX, OKIN_OPTIONS } from '../../../../utils/const'
import { buildDefaultHeaders } from '../../../../actions/helper'
import { useSelector } from 'react-redux'

import Header from './Header'
import GeneralTable from './GeneralTable'
import ResultsTable from './ResultsTable'
import ResultsFooter from './ResultsFooter'
import PracticeTable from './PracticeTable'

const Structure = () => {
  const history = useHistory()
  const { id } = useParams()
  const state = useSelector(state => state)

  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState('structure')

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/epcr/structure_compliance/${id}`,
        buildDefaultHeaders({ auth: state.auth })
      )

      if (response.ok) {
        const result = await response.json()
        setData(result)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [id])

  const goBack = () => {
    history.push('/dashboard_new/edu_prog')
  }

  const { accordance, general, structure, program_name, okin_id, practice } = data || {}

  // Группируем structure по блокам
  const groupedStructure = useMemo(() => {
    const result = []
    if (structure) {
      let currentBlock = null
      structure.forEach(item => {
        if (item.row_type === 0 && item.block_id) {
          currentBlock = {
            ...item,
            courses: []
          }
          result.push(currentBlock)
        } else if (item.row_type === 1 && currentBlock) {
          currentBlock.courses.push(item)
        }
      })
    }
    return result
  }, [structure])

  // Итоговая строка (row_type === 0 без block_id)
  const totalRow = structure?.find(item => item.row_type === 0 && !item.block_id)

  // Подсчёт общей трудоёмкости
  const totals = useMemo(() => {
    if (!groupedStructure.length) return { ze: 0, hours: 0, baseZe: 0, varZe: 0 }
    return groupedStructure.reduce((acc, block) => ({
      ze: acc.ze + (block.labour_intensity_ze || 0),
      hours: acc.hours + (block.hours || 0),
      baseZe: acc.baseZe + (block.base_labour || 0),
      varZe: acc.varZe + (block.var_labour || 0),
    }), { ze: 0, hours: 0, baseZe: 0, varZe: 0 })
  }, [groupedStructure])

  // Недостающие дисциплины (kt_check === false)
  const missingDisciplines = useMemo(() => {
    if (!structure) return []
    return structure.filter(item => item.kt_check === false && item.course_name)
  }, [structure])

  const formatFgosTotal = (item) => {
    if (item.fgos_total_max) {
      return `${item.fgos_total} - ${item.fgos_total_max}`
    }
    if (item.fgos_total) {
      return `≤ ${item.fgos_total} ()`
    }
    return null
  }

  const formatLabour = (ze, hours) => {
    if (ze === null && hours === null) return null
    return `${ze || ''} (${hours || ''})`
  }

  return (
    <div className={styles.structureWrap}>
      <Header
        title={program_name}
        levelStudy={OKIN_OPTIONS.find(item => item.value === okin_id)?.label}
        onBack={goBack}
        accordance={accordance}
        general={general}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <ReactLoader loaded={!loading} color='#5b76e5'>
        {data && (
          <>
            <GeneralTable general={general} />

            <ResultsTable
              groupedStructure={groupedStructure}
              totalRow={totalRow}
              totals={totals}
              formatLabour={formatLabour}
              formatFgosTotal={formatFgosTotal}
            />

            <ResultsFooter missingDisciplines={missingDisciplines} />

            <PracticeTable data={practice} />

          </>
        )}
      </ReactLoader>
    </div>
  )
}

export default Structure
